import environment from "web/script/modules/environment";
import userProfiler from "web/script/modules/userprofiler";
import { isActiveBanner } from "web/script/utils/active-campaigns";
import browser from "web/script/utils/browser";
import storage from "web/script/utils/storage";

const RETAILER_RETURN_BANNER_FLAG = "mg_app_banner_retailer_return";
const ARMED_KEY = "retailer_return_banner_armed";
const SHOWN_KEY = "retailer_return_banner_shown";

export type TriggerPage = "feed" | "product";

export function isRetailerReturnBannerEligible(): boolean {
    return (
        Boolean(browser.isSupportedIos) &&
        isActiveBanner(RETAILER_RETURN_BANNER_FLAG) &&
        !storage.get(SHOWN_KEY, false, true) &&
        !userProfiler.hasRetailerReturnBannerBeenDismissed()
    );
}

export function armRetailerReturnBanner(): void {
    if (isRetailerReturnBannerEligible()) {
        const triggerPage: TriggerPage =
            environment.get("pageType") === "product_overlay" ? "feed" : "product";
        storage.set(ARMED_KEY, triggerPage, true);
    }
}

export function isRetailerReturnBannerArmed(): boolean {
    return Boolean(storage.get(ARMED_KEY, false, true));
}

export function consumeRetailerReturnBannerArm(): TriggerPage | null {
    const triggerPage = storage.get(ARMED_KEY, null, true) as TriggerPage | null;
    storage.remove(ARMED_KEY, true);
    return triggerPage || null;
}

export function markRetailerReturnBannerShown(): void {
    storage.set(SHOWN_KEY, true, true);
}
